import { FC } from 'react'

type Props = {
  src: string
  title: string
}

const Component: FC<Props> = ({ src, title }) => {
  return (
    <div className="flex flex-col justify-center items-center gap-9">
      <img src={src} alt={title} />
      <p className="text-xl">{title}</p>
    </div>
  )
}

export default Component
